export const ColorCarousel = (function () {
  let init = (pageId) => {
    let badge = $('.kt-badge--bbw-color');
    let carousel = $('.colors-owl-carousel');
    if (pageId) {
      badge = $('.kt-badge--bbw-color', pageId);
      carousel = $('.owl-carousel', pageId);
    }

    badge.popover({
      content: function () {
        let src = $(this).data('image');
        return $(`<div class="img-bg-square"/>`).css({ backgroundImage: `url(${src})` });
      },
      html: true,
      trigger: 'hover',
      container: 'body',
      placement: 'top',
      template: `<div class="popover color-popover" role="tooltip">
                    <div class="arrow"></div>
                    <div class="popover-body"></div>
                    <h3 class="popover-header"></h3>
                 </div>`
    });

    carousel.owlCarousel({
      dots: false,
      nav: true,
      autoWidth: true,
      slideBy: 3,
      margin: 3
    });
  };

  return {
    init
  };
})();
